import { render, staticRenderFns } from "./GrowthValueFlow.vue?vue&type=template&id=39638141&scoped=true&"
import script from "./GrowthValueFlow.vue?vue&type=script&lang=js&"
export * from "./GrowthValueFlow.vue?vue&type=script&lang=js&"
import style0 from "./GrowthValueFlow.vue?vue&type=style&index=0&id=39638141&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39638141",
  null
  
)

export default component.exports